import Carousel from "../components/Carousel";
import SectionHeading from "../components/SectionHeading";
import Reveal from "../components/Reveal";
import GridTexture from "../components/GridTexture";

// Import league logos
import botola from "../assets/cover/league/Logo_Botola_12.2019.jpg";
import premierLeague from "../assets/cover/league/Premier_League_Logo.svg.png";
import ufc from "../assets/cover/league/UFC_Logo.png";
import belgianPro from "../assets/cover/league/belgian_pro_league-logo_brandlogos.net_gej8f.png";
import cff from "../assets/cover/league/cff.png";
import hburt from "../assets/cover/league/hburt.webp";
import hg1 from "../assets/cover/league/hg-1-scaled.png";
import hh from "../assets/cover/league/hh.png";
import hhbnnjh from "../assets/cover/league/hhbnnjh.png";
import oikj from "../assets/cover/league/oikj-scaled.png";
import rsl from "../assets/cover/league/rsl.png";
import serieA from "../assets/cover/league/serie_a-logo_brandlogos.net_kmz4e.png";
import tz1 from "../assets/cover/league/tz-1.png";
import u from "../assets/cover/league/u.png";
import uhkojlk from "../assets/cover/league/uhkojlk.png";
import zhg from "../assets/cover/league/zhg.png";
import zhjik from "../assets/cover/league/zhjik-scaled.png";
import mls from "../assets/cover/league/Major.webp";

// Dynamically import all sports posters in assets/cover/sports
const sportsContext = require.context("../assets/cover/sports", false, /\.(png|jpe?g|svg|webp)$/);
const sportsImages = sportsContext.keys().map((key) => sportsContext(key));

const leagueLogos = [
  { name: "ZHJ", src: zhjik },
  { name: "U", src: u },
  { name: "Jupiler Pro League", src: belgianPro },
  { name: "Premier League", src: premierLeague },
  { name: "OIKJ", src: oikj },
  { name: "Serie A", src: serieA },
  { name: "Saudi Pro League", src: rsl },
  { name: "Botola Pro", src: botola },
  { name: "UFC", src: ufc },
  { name: "CAF", src: cff },
  { name: "HB", src: hburt },
  { name: "HG1", src: hg1 },
  { name: "HH", src: hh },
  { name: "HHBN", src: hhbnnjh },
  { name: "TZ1", src: tz1 },
  { name: "UHK", src: uhkojlk },
  { name: "ZHG", src: zhg },
  { name: "MLS", src: mls },
];

export default function Sports() {
  return (
    <section
      id="sport"
      className="py-14 sm:py-20 bg-surface-primary relative overflow-hidden"
      style={{ "--section-bg": "#000000" }}
    >
      <GridTexture />
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative">
        <SectionHeading
          kicker="Sport &amp; competities"
          title={
            <>
              Live Sport &amp;{" "}
              <span className="text-transparent bg-clip-text bg-gradient-text">
                Premium Sportcontent
              </span>
            </>
          }
          subtitle="Ontdek alle sportkanalen en je favoriete wedstrijden in één abonnement"
        />

        {/* Sport cards carousel */}
        <Reveal>
          <Carousel
            items={sportsImages}
            keyExtractor={(src) => src}
            speed={1}
            direction="reverse"
            renderItem={(src, index) => (
              <div className="w-40 h-64 sm:w-48 sm:h-72 md:w-52 md:h-[22rem] rounded-2xl overflow-hidden border border-line shadow-md hover:shadow-glow-cyan-sm hover:border-accent/50 transition-all duration-500 group">
                <img
                  src={src}
                  alt={`Sportcompetitie ${(index % sportsImages.length) + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                  draggable={false}
                />
              </div>
            )}
          />
        </Reveal>

        {/* League logos */}
        <div className="mt-12 sm:mt-16">
          <p className="text-center text-xs sm:text-sm font-bold uppercase tracking-[0.18em] text-ink-muted mb-6">
            Alle grote competities in één abonnement
          </p>
          <Carousel
            items={leagueLogos}
            keyExtractor={(logo) => logo.name}
            speed={0.4}
            gapClassName="gap-3 sm:gap-4"
            renderItem={(logo) => (
              <div className="w-24 sm:w-28 bg-white rounded-lg sm:rounded-xl p-3 sm:p-4 shadow-md hover:shadow-glow-cyan-sm transition-all duration-300 hover:scale-105 border border-white/10 hover:border-accent/40">
                <div className="flex items-center justify-center h-7 sm:h-8">
                  <img
                    src={logo.src}
                    alt={logo.name}
                    className="max-h-7 sm:max-h-8 max-w-full object-contain"
                    loading="lazy"
                    draggable={false}
                  />
                </div>
              </div>
            )}
          />
        </div>
      </div>
    </section>
  );
}
